<script>
import BaseFilter from '@/modules/_global/_components/filters/BaseAutocompleteSearchRequestFilter.vue';
import { WarehouseDevicesService } from '@/services/warehouse-devices.service';

export default {
  name: 'ListFilter',

  extends: BaseFilter,

  methods: {
    getData() {
      return WarehouseDevicesService.getFilteredList({ search: this.search })
        .then(({ data }) => {
          return data.data;
        })
        .catch(console.error);
    }
  }
};
</script>
